import { render, staticRenderFns } from "./homeNavigation.vue?vue&type=template&id=8c98fc4e&scoped=true"
import script from "./homeNavigation.vue?vue&type=script&lang=js"
export * from "./homeNavigation.vue?vue&type=script&lang=js"
import style0 from "./homeNavigation.vue?vue&type=style&index=0&id=8c98fc4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c98fc4e",
  null
  
)

export default component.exports